import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  change(event) {
    const cycle = event.currentTarget.dataset.cycle

    this.element.querySelectorAll("[data-cycle]").forEach(button => {
      const selected = button.dataset.cycle === cycle
      button.classList.toggle("active", selected)
      button.setAttribute("aria-pressed", String(selected))
    })

    this.element.querySelectorAll(".plan-price[data-monthly]").forEach(price => {
      price.querySelector(".plan-price-num").textContent = price.dataset[cycle]
    })
    this.element.querySelectorAll(".plan-bill[data-monthly-text]").forEach(bill => {
      bill.textContent = cycle === "annual" ? bill.dataset.annualText : bill.dataset.monthlyText
    })
  }
}
